
export async function asyncSetTimeout(fn:()=>Promise<void>, ms:number){
    return new Promise<void>(resolve => {
        setTimeout(async ()=>{
            await fn();
            resolve();
        }, ms);
    });
}

export async function sleep(ms:number) {
    await timeout(ms);
}

function timeout(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}